





























































import { Empty } from 'ant-design-vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { turnoverRank } from '@/api/statistic-analysis/index';

@Component
export default class ChartRight extends Vue {
  @Prop({ default: () => {} })
  filterParam: any;
  @Prop({ default: () => [] })
  selectParkIds: any[];

  simpleImage: any = (Empty as any).PRESENTED_IMAGE_SIMPLE; // 无数据UI

  current: number = 1;
  pageSize: number = 10;
  total: number = 0;
  tableData: any[] = [];
  tableLoading: boolean = false;

  async fetchRankData(current?: number, selectParkIds?: any) {
    if (selectParkIds && selectParkIds.length === 1) {
      this.tableData = [];
      return;
    }
    if (current) {
      this.current = current;
    }
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      let param: any = {
        parkIds: selectParkIds ? selectParkIds.join(',') : '',
        reportDateStart: this.filterParam.startTime,
        reportDateEnd: this.filterParam.endTime,
        currPage: this.current,
        pageSize: this.pageSize
      };
      let res = await turnoverRank(param);
      const data = res.data;
      if (data) {
        const { totalNum = 0, datas = [] } = data;
        this.total = Number(totalNum);
        this.tableData = datas;
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;

    this.fetchRankData();
  }

  mounted() {
    this.fetchRankData();
  }
}
